const { debounce } = window.BAO.Utils
const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins

class SearchCtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.checkSetupCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.checkSetupCarousel()
      }, 500),
    )
  }

  checkSetupCarousel () {
    if (!window.BAO.MediaBreakpoints.isXsViewport) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 10,
        },
      },
      [
        setInitialised(),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('search-cta-carousel')) {
  customElements.define('search-cta-carousel', SearchCtaCarousel)
}
